import { auth, profile } from '@/api'
import {
	AUTH_GOOGLE_PROFILE_GET_ERROR,
	AUTH_LOG_IN_ERRORS,
	AUTH_PROFILE_GET,
	AUTH_PROFILE_GET_ERROR,
	AUTH_PROFILE_UPDATE,
	AUTH_PROFILE_UPDATE_ERROR,
	AUTH_LOADING_STATUS,
	AUTH_GET_CATEGORIES_LOG_IN,
	AUTH_GET_CATEGORIES_REGISTER,
	AUTH_MAP_REGISTER,
	AUTH_GET_CATEGORIES_LOADING,
	AUTH_PROFILE_SETTINGS,
	AUTH_PROFILE_SETTINGS_ERROR,
	AUTH_PROFILE_SETTINGS_LOADING,
    AUTH_PROFILE_SECTION,
    AUTH_PROFILE_SECTION_ERROR,
	AUTH_PROFILE_SECTION_LOADING,
	AUTH_PROFILE_SECTION_CLEAR
} from './types'
import {getSafeDwhCreds} from "@/utils/helpers";

import { APP_SHOW_ALERT, APP_HIDE_ALERT } from '../app/types'
import firebase from 'firebase/compat'
import TokenService from '@/services/token.service'

const getMapRegisterToken = async (ctx) => {
	try {
		ctx.commit(AUTH_LOADING_STATUS, true)
		const { data } = await auth.getMapToken()
		ctx.commit(AUTH_MAP_REGISTER, data)
	} catch (e) {
		console.error(e)
	} finally {
		ctx.commit(AUTH_LOADING_STATUS, false)
	}
}
const login = async (ctx, credentials) => {
    try {
        ctx.commit(AUTH_LOADING_STATUS, true)

        const {
            data: { token, device_id },
        } = await auth.login(credentials)

        TokenService.saveAccessToken(token)
        TokenService.saveDeviceId(device_id)
        TokenService.saveEmail(credentials.login)

        await ctx.dispatch('getProfile')
        const dwhCreds = getSafeDwhCreds()
        if (dwhCreds) {
            ctx.dispatch(
                'settings/sendDwhAction',
                {
                    credentials: dwhCreds,
                    payload: {
                        category: 'App Start',
                        action: 'login_finish',
                        module: 'App Launch',
                        session_id: ctx.rootGetters['app/sessionId'],
                        version: process.env.VUE_APP_VERSION,
                        platform: 'web app',
                        login: credentials.login,
                        data: 'Success',
                    },
                },
                { root: true }
            ).catch(() => {})
        }

        return true
    } catch (e) {
        console.error(e)

        const errorMessage =
            e?.response?.data?.[0]?.message ||
            e?.response?.data?.message ||
            e?.message ||
            'Login failed'
        ctx.commit(AUTH_LOG_IN_ERRORS, errorMessage)

        const dwhCreds = getSafeDwhCreds()
        if (dwhCreds) {
            ctx.dispatch(
                'settings/sendDwhAction',
                {
                    credentials: dwhCreds,
                    payload: {
                        category: 'App Start',
                        action: 'login_finish',
                        module: 'App Launch',
                        session_id: ctx.rootGetters['app/sessionId'],
                        version: process.env.VUE_APP_VERSION,
                        platform: 'web app',
                        login: credentials.login,
                        data: 'Error',
                    },
                },
                { root: true }
            ).catch(() => {})
        }

        throw e
    } finally {
        ctx.commit(AUTH_LOADING_STATUS, false)
    }
}

export const signUp = async (ctx, payload) => {
	ctx.commit(AUTH_LOADING_STATUS, true)

	try {
		const res = await auth.register(payload)
		const { status, data } = res

		switch (status) {
			case 200:
				return true
			case 423:
				showAlert(ctx, data?.[0]?.message, 'success')
				return false
			case 422:
				showAlert(ctx, data?.[0]?.message, 'error')
				return false
			default:
				showAlert(ctx, `Unexpected status: ${status}`, 'error')
				return false
		}
	} catch (e) {
		const msg = e.response?.data?.[0]?.message || e.message || 'Network error'
		showAlert(ctx, msg, 'error')
		if (e.response?.status === 423) {
			window.location.href = `${window.location.origin}/webapp/auth/welcome`
		}
		return false
	} finally {
		ctx.commit(AUTH_LOADING_STATUS, false)
	}
}

function showAlert(ctx, payloadOrMessage, maybeType) {
    let message, type, timeout

    if (payloadOrMessage && typeof payloadOrMessage === 'object' && 'message' in payloadOrMessage) {
        message = payloadOrMessage.message
        type = payloadOrMessage.type || 'success'
        timeout = payloadOrMessage.timeout || 5000
    } else {
        message = String(payloadOrMessage)
        type = maybeType || 'success'
        timeout = 5000
    }

    const closeTimeout = setTimeout(() => {
        ctx.commit(`app/${APP_HIDE_ALERT}`, {}, { root: true })
    }, timeout)

    ctx.commit(
        `app/${APP_SHOW_ALERT}`,
        { message, type, closeTimeout },
        { root: true }
    )
}
const logout = async () => {
	try {
		await auth.logout()
	} catch (e) {
		console.error(e)
	} finally {
		TokenService.clearStorageTokens()
		TokenService.removeDeviceId()
		localStorage.removeItem('settings')
		localStorage.removeItem('additionalLoginSettings')
		window.location.href = `${window.location.origin}/webapp/auth/welcome`
	}
}

const getProfile = async (ctx) => {
	try {
		ctx.commit(AUTH_LOADING_STATUS, true)
		const { data } = await profile.getProfile()

		if (!data) {
			throw 'Unauthorized'
		}

		ctx.commit(AUTH_PROFILE_GET, data)
	} catch (e) {
		ctx.commit(AUTH_PROFILE_GET_ERROR)
		console.log(e)
	} finally {
		ctx.commit(AUTH_LOADING_STATUS, false)
	}
}

const updateProfile = async (ctx, profileData) => {
	try {
		const { data } = await profile.updateProfile(profileData)
		ctx.commit(AUTH_PROFILE_UPDATE, data)
	} catch (e) {
		ctx.commit(AUTH_PROFILE_UPDATE_ERROR)
		console.log(e)
	}
}

const signInWithApple = async (ctx) => {
	const provider = new firebase.auth.OAuthProvider('apple.com')

	try {
		const { user } = await firebase.auth().signInWithPopup(provider)
		const accessToken = user.multiFactor.user.accessToken
		const payload = {
			token: accessToken,
			user: {
				email: user.multiFactor.user.email,
				name: user.multiFactor.user.displayName,
				photoUrl:
					'https://www.pinpng.com/pngs/m/341-3415688_no-avatar-png-transparent-png.png',
			},
		}
		ctx.dispatch('sendAuthDataToAPI', payload)
	} catch (e) {
		ctx.commit(AUTH_GOOGLE_PROFILE_GET_ERROR, e)
		console.error(e)
		throw e
	}
}

const signInWithFacebook = async (ctx) => {
	const provider = new firebase.auth.FacebookAuthProvider()
	try {
		const { user } = await firebase.auth().signInWithPopup(provider)
		const accessToken = user.multiFactor.user.accessToken
		const payload = {
			token: accessToken,
			user: {
				email: user.multiFactor.user.email,
				name: user.multiFactor.user.displayName,
				photoUrl: user.multiFactor.user.photoURL,
			},
		}
		if (!payload.user.email) {
			throw 'Please add e-mail address to your facebook account or choose another authorization provider'
		}
		ctx.dispatch('sendAuthDataToAPI', payload)
	} catch (e) {
		if (e.message.endsWith('(auth/account-exists-with-different-credential).')) {
			ctx.commit(
				AUTH_GOOGLE_PROFILE_GET_ERROR,
				'An account already exists with the same email address but different sign-in credentials'
			)
		} else {
			ctx.commit(AUTH_GOOGLE_PROFILE_GET_ERROR, e)
		}
		console.error(e)
		throw e
	}
}

const signInWithGoogle = async (ctx) => {
	const provider = new firebase.auth.GoogleAuthProvider()

	try {
		const { user } = await firebase.auth().signInWithPopup(provider)

		const token = await user.getIdToken()
		const payload = {
			token,
			user: {
				email: user.email,
				name: user.displayName,
				photoUrl: user.photoURL,
			},
		}
		ctx.dispatch('sendAuthDataToAPI', payload)
	} catch (e) {
		ctx.commit(AUTH_GOOGLE_PROFILE_GET_ERROR, e)
		console.error(e)
		throw e
	}
}

const sendAuthDataToAPI = async (ctx, payload) => {
	try {
		await auth.socialLogin(payload)
		ctx.dispatch('getProfile')

		return true
	} catch (e) {
		ctx.commit(AUTH_GOOGLE_PROFILE_GET_ERROR, e.response.data.message)
		console.error(e)
		throw e
	}
}

const restoreUserPassword = async (ctx, payload) => {
	try {
		ctx.commit(AUTH_LOADING_STATUS, true)
		const { data } = await auth.restorePassword(payload)
		return data
	} catch (e) {
		console.error(e)

		const errorMessage = e.response.data[0]?.message || e.response.data.message
		ctx.commit(AUTH_LOG_IN_ERRORS, errorMessage)
	} finally {
		ctx.commit(AUTH_LOADING_STATUS, false)
	}
}
const getLogInCategory = async (ctx) => {
	ctx.commit(AUTH_GET_CATEGORIES_LOADING, true)
	try {
		const { data } = await auth.getLoginInCategories()
		ctx.commit(AUTH_GET_CATEGORIES_LOG_IN, data)
	} catch (e) {
		console.error(e)
	} finally {
		ctx.commit(AUTH_GET_CATEGORIES_LOADING, false)
	}
}
const getRegisterCategories = async (ctx) => {
	ctx.commit(AUTH_GET_CATEGORIES_LOADING, true)
	try {
		const { data } = await auth.getRegistrationCategories()
		ctx.commit(AUTH_GET_CATEGORIES_REGISTER, data)
	} catch (e) {
		console.error(e)
	} finally {
		ctx.commit(AUTH_GET_CATEGORIES_LOADING, false)
	}
}

const clearCategories = async (ctx) => {
	ctx.commit(AUTH_GET_CATEGORIES_LOG_IN, [])
	ctx.commit(AUTH_GET_CATEGORIES_REGISTER, [])
}
const getSettings = async (ctx) => {
	ctx.commit(AUTH_PROFILE_SETTINGS_LOADING, true)
	try {
		const { data } = await profile.getAccountSettings()
		ctx.commit(AUTH_PROFILE_SETTINGS, data)
	} catch (e) {
		ctx.commit(AUTH_PROFILE_SETTINGS_ERROR, e)
	} finally {
		ctx.commit(AUTH_PROFILE_SETTINGS_LOADING, false)
	}
}
const changePassword = async (ctx, { id, user_password }) => {
	ctx.commit(AUTH_LOADING_STATUS, true)
	try {

		await profile.changePassword({ id, user_password })

		showAlert(ctx, 'Password changed successfully', 'success')
	} catch (e) {
		console.error(e)

		const errorMessage =
			e?.response?.data?.[0]?.message ||
			e?.response?.data?.message ||
			'Failed to change password'

		showAlert(ctx, errorMessage, 'error')
	} finally {
		ctx.commit(AUTH_LOADING_STATUS, false)
	}
}

const deleteAccount = async (ctx, id) => {
	ctx.commit(AUTH_LOADING_STATUS, true)
	try {
		await profile.deleteAccount(id)
		showAlert(ctx, 'Account deleted', 'success')
		return true
	}
	catch (e) {
		console.error(e)
		showAlert(ctx, e?.message || 'Failed to delete account', 'error')
		return false
	} finally {
		TokenService.clearStorageTokens()
		TokenService.removeDeviceId()
		localStorage.removeItem('settings')
		localStorage.removeItem('additionalLoginSettings')
		window.location.href = `${window.location.origin}/webapp/auth/welcome`
		ctx.commit(AUTH_LOADING_STATUS, false)
	}
}

const getProfileSection = async (ctx, section) => {
	ctx.commit(AUTH_PROFILE_SECTION_LOADING, true)
	try {
		const {data} = await profile.getUserSection(section)
		ctx.commit(AUTH_PROFILE_SECTION, data)
		ctx.commit(AUTH_PROFILE_SECTION_LOADING, false)
	} catch (e) {
		console.error(e)
		ctx.commit(AUTH_PROFILE_SECTION_ERROR, e)
	} finally {
		ctx.commit(AUTH_PROFILE_SECTION_LOADING, false)
	}
}

const clearProfileSection = async (ctx) => {
	try{
		ctx.commit(AUTH_PROFILE_SECTION_CLEAR)
	} catch (e) {
		console.error(e)
	}
}

const visibilityChange = async (ctx,payload) => {
	try {
		const {data} = await profile.visibilityChange(payload)
		ctx.commit(AUTH_PROFILE_SECTION, data)
	} catch (e) {
		console.error(e)
	}
}

export default {
	login,
	logout,
	getProfile,
	signInWithGoogle,
	sendAuthDataToAPI,
	updateProfile,
	signInWithFacebook,
	signInWithApple,
	restoreUserPassword,
	signUp,
	getLogInCategory,
	getRegisterCategories,
	clearCategories,
	getMapRegisterToken,
    showAlert,
	getSettings,
	changePassword,
	deleteAccount,
	getProfileSection,
	visibilityChange,
	clearProfileSection
}
